import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Checkbox,
  FormControlLabel,
  Paper,
  Container,
  Autocomplete,
  Stack,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import GenericButton from "../../components/Custom/GenericButton";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { useAlert } from "../../components/Alert";
import api from "../../globals/axios";

const CreateProgram = () => {
  const { t } = useTranslation();
  const { showAlert } = useAlert();
  const [crops, setCrops] = useState([]);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    commodity: "",
    cycle: "",
    is_ratoon: false,
  });

  useEffect(() => {
    fetchCommodities();
  }, []);

  const fetchCommodities = async () => {
    try {
      const response = await api.get("/common/commodities/");
      setCrops(response.data || []);
    } catch (error) {
      console.error("Error fetching commodities:", error);
      showAlert("error", t("Failed to fetch crops"));
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const requestData = {
        name: formData.name,
        commodity: formData.commodity,
      };
      const selectedCrop = crops.find((crop) => crop.id === formData.commodity);
      if (selectedCrop?.name?.toLowerCase() === "sugarcane") {
        requestData.cycle = formData.cycle;
        requestData.is_ratoon = !!formData.is_ratoon;
      }
      const response = await api.post(
        "/farm-activities/create-program/",
        requestData
      );
      showAlert("success", t("Program created successfully"));
      navigate(`/pop-manager/program/${response.data.data.id}/create-stage/`);
    } catch (error) {
      console.error("Error creating program:", error);
      showAlert("error", t("Failed to create program"));
    }
  };

  return (
    <Container
      maxWidth="xs"
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <CustomTitle>{t("Create Program")}</CustomTitle>
      <form onSubmit={handleSubmit}>
        <Paper elevation={0} sx={{ p: 2 }}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <Autocomplete
              disablePortal
              fullWidth
              options={crops}
              value={
                crops.find((crop) => crop.id === formData.commodity) || null
              }
              getOptionLabel={(option) => option.name || ""}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              renderInput={(params) => (
                <TextField {...params} label="Crop" required />
              )}
              onChange={(event, newValue) => {
                setFormData((prev) => ({
                  ...prev,
                  commodity: newValue?.id || "",
                }));
              }}
            />

            {crops
              .find((crop) => crop.id === formData.commodity)
              ?.name?.toLowerCase() === "sugarcane" && (
              <>
                <FormControl fullWidth>
                  <InputLabel id="cycle">{t("Cycle")}</InputLabel>
                  <Select
                    labelId="cycle"
                    id="cycle-select"
                    name="cycle"
                    value={formData.cycle}
                    label={t("Cycle")}
                    onChange={handleChange}
                  >
                    <MenuItem value="short">{t("Short")}</MenuItem>
                    <MenuItem value="long">{t("Long")}</MenuItem>
                  </Select>
                </FormControl>

                <FormControlLabel
                  control={
                    <Checkbox
                      name="is_ratoon"
                      checked={formData.is_ratoon}
                      onChange={handleChange}
                      color="success"
                    />
                  }
                  label="Is Ratoon"
                />
              </>
            )}

            <Box textAlign="center">
              <GenericButton
                backgroundColor="primary"
                fontColor="#fff"
                padding="6px 0px"
                type="submit"
              >
                {t("Submit")}
              </GenericButton>
            </Box>
          </Stack>
        </Paper>
      </form>
    </Container>
  );
};

export default CreateProgram;
